mutation UpdateGetStartedPreferences(
  $whoFor: UpdategetstartedpreferencesWhofor!
  $giftType: UpdategetstartedpreferencesGifttype
  $givenName: String
  $middleName: String
  $familyName: String
) {
  updateGetStartedPreferences(
    whoFor: $whoFor
    giftType: $giftType
    givenName: $givenName
    middleName: $middleName
    familyName: $familyName
  )
}
